import { MutationTree } from 'vuex'

import { ShopState } from '@/types/store'
import { IShop, ShopType } from '@/types/shop'

export const mutations: MutationTree<ShopState> = {
  shopsLoadStart(state) {
    state.isShopsLoading = true
  },
  shopsLoaded(state, payload: IShop[]) {
    state.shops = payload
    state.isShopsLoading = false
  },
  setShopType(state, shopType: ShopType): void {
    state.shopType = shopType
  },
}
